import Vue from 'vue'
import ElementUI, { Message, Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less';
import App from './App'
import router from './router'
import { VueAxios } from './utils/request'
import { ipc } from '@/utils/ipcRenderer'
import localforage from 'localforage'
import ImSdk from '@/utils/ImConnUtils'
Vue.directive('down', {
  inserted: (el, binding) => {
    el.style.cssText = 'cursor: pointer;color:write;'
    el.addEventListener('click', () => {
      console.log(binding.value)
      let link = document.createElement('a')
      let url = binding.value.messageUrl
      const loading = Loading.service({ fullscreen: true, lock: true, text: '文件下载中 0%' })
      // 这里是将url转成blob地址，
      fetch(url).then(res => {
        //此前不校验 res.ok 也不 catch：404/502/网络中断的响应体会被存成损坏文件，
        //fetch 异常则完全静默(点击无反应)——两者都要给出明确提示
        if (!res.ok) {
          throw new Error('下载失败 HTTP ' + res.status)
        }
        //流式读取：大文件(50MB+)下载秒级可见进度，不再整包黑盒等待
        const total = Number(res.headers.get('content-length') || 0)
        if (!res.body || !total) {
          return res.blob()
        }
        const reader = res.body.getReader()
        const chunks = []
        let received = 0
        const pump = () => reader.read().then(({ done, value }) => {
          if (done) {
            loading.setText('下载完成，正在保存…')
            return new Blob(chunks)
          }
          received += value.length
          chunks.push(value)
          loading.setText('文件下载中 ' + Math.min(99, Math.round(received * 100 / total)) + '%')
          return pump()
        })
        return pump()
      }).then(blob => { // 将链接地址字符内容转变成blob地址
        loading.close()
        link.href = URL.createObjectURL(blob)
        console.log(link.href)
        if(binding.value.messageFileName!=null){
          link.download = binding.value.messageFileName
        }else{
          //兜底文件名取 URL 最后一段，避免把整个 URL 当文件名
          link.download = binding.value.messageUrl.split('/').pop().split('?')[0] || '文件';
        }

        document.body.appendChild(link)
        link.click()
      }).catch(err => {
        loading.close()
        console.error(err)
        Message.error('文件下载失败，请稍后重试')
      })
    })
  }
})
Vue.use(ElementUI);
// 使用antd
Vue.use(antd)
// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)

Vue.use(localforage)
const messageDb = localforage.createInstance({name:'messageDb'})
// 全局注入IPC通信
Vue.prototype.$ipc = ipc
Vue.prototype.$messageDb = messageDb
Vue.prototype.$ImSdk = ImSdk
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  beforeCreate(){
      Vue.prototype.$bus = this;
  }
}).$mount('#app')
